/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';

import { LmsCalenderComponent } from './component/lms-calender/lms-calender.component';
import { LmsHeaderSubTypesComponent } from './component/lms-header-sub-types/lms-header-sub-types.component';
import { LmsHistoryDataComponent } from './component/lms-history-data/lms-history-data.component';
import { LmsHistoryHeaderSubTypeComponent } from './component/lms-history-header-sub-type/lms-history-header-sub-type.component';
import { LmsLocoContextMenuComponent } from './component/lms-loco-context-menu/lms-loco-context-menu.component';
import { LmsLocoSvgComponent } from './component/lms-loco-svg/lms-loco-svg.component';
import { LmsMessageTabComponent } from './component/lms-message-tab/lms-message-tab.component';
import { LmsNotesDataListComponent } from './component/lms-notes-data-list/lms-notes-data-list.component';
import { LmsNotesDataComponent } from './component/lms-notes-data/lms-notes-data.component';
import { LmsNotesHeaderComponent } from './component/lms-notes-header/lms-notes-header.component';
import { LmsStationContextMenuComponent } from './component/lms-station-context-menu/lms-station-context-menu.component';
import { LmsStationIconSvgComponent } from './component/lms-station-icon-svg/lms-station-icon-svg.component';
import { LmsTrainContextMenuComponent } from './component/lms-train-context-menu/lms-train-context-menu.component';
import { LmsTrainSvgComponent } from './component/lms-train-svg/lms-train-svg.component';
import { PopupComponent } from './component/popup/popup.component';
import { SpinnerComponent } from './component/spinner/spinner.component';
import { ThpHistoryDataComponent } from './component/thp-history-data/thp-history-data.component';
import { LmsDropZoneDirective } from './directives/lms-drop-zone.directive';
import { LmsViewportPagingDirective } from './directives/lms-viewport-paging.directive';
import { HistorySortPipe } from './pipes/history-sort.pipe';
import { KeysPipe } from './pipes/keys.pipe';
import { ThpHistorySortPipe } from './pipes/thp-history-sort.pipe';
import { NotesDataService } from './services/note-data.service';


/**
 * @export
 * @class SharedModule
 */
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DialogModule,
    FormsModule,
    RadioButtonModule,
    DropdownModule,
    TableModule,
    OverlayPanelModule,
    ContextMenuModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [LmsLocoSvgComponent,
    LmsLocoContextMenuComponent,
    LmsDropZoneDirective,
    LmsTrainSvgComponent,
    LmsStationIconSvgComponent,
    KeysPipe,
    LmsTrainContextMenuComponent,
    LmsViewportPagingDirective,
    LmsMessageTabComponent,
    LmsHeaderSubTypesComponent,
    PopupComponent,
    LmsHistoryHeaderSubTypeComponent,
    LmsHistoryDataComponent,
    ThpHistoryDataComponent,
    LmsNotesDataComponent,
    LmsNotesHeaderComponent,
    LmsNotesDataListComponent,
    HistorySortPipe,
    ThpHistorySortPipe,
    LmsStationContextMenuComponent,
    LmsCalenderComponent,
    SpinnerComponent],
  exports: [
    LmsLocoSvgComponent,
    LmsLocoContextMenuComponent,
    LmsTrainContextMenuComponent,
    LmsStationContextMenuComponent,
    LmsTrainSvgComponent,
    LmsStationIconSvgComponent,
    KeysPipe,
    LmsViewportPagingDirective,
    LmsMessageTabComponent,
    LmsHeaderSubTypesComponent,
    PopupComponent,
    LmsDropZoneDirective,
    LmsHistoryHeaderSubTypeComponent,
    LmsHistoryDataComponent,
    ThpHistoryDataComponent,
    LmsNotesDataListComponent,
    LmsCalenderComponent,
    SpinnerComponent
  ],
  providers: [NotesDataService]
})
export class SharedModule { }
